import { bootstrapApplication } from '@angular/platform-browser';
import { loadEgBrand } from '@expertgroup/shell/brand';
import { createAppConfig } from './app.config';
import { AppComponent } from './app.component';
import { environment } from './environments/environment';

// The mask (maska) comes first: the look of the host this page is served on, from Identity (shell 0.16, ADR 0003). One GET to
// the CONFIGURED issuer's /branding/by-host before Angular starts, so the rail is drawn in the host's look from the first
// frame. It costs one round trip, 2 s at worst; after the first load the tab keeps a sessionStorage snapshot and waits for the
// network at most 300 ms. It never rejects: a host nobody has claimed (localhost, the Static Web App hosts) or an Identity that
// does not answer is null — Identity's generic look (the product name, no logo). This app has no browser telemetry, so nothing
// adds a traceparent header to that GET (a header would turn this simple CORS request into a preflight the endpoint does not
// answer).
//
// The OIDC auth-code callback is processed by angular-auth-oidc-client's checkAuth(), invoked in the app initializer
// (see app.config.ts) BEFORE the router navigates — no manual redirect handling here.
loadEgBrand({ issuer: environment.issuer })
    .then((brand) => bootstrapApplication(AppComponent, createAppConfig(brand)))
    .catch((err) => console.error(err));
